/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { EmptyRequest } from '../models/empty.request';
import { MemoryPhase } from '../models/memory-phase.entity';

export type MemoryPhaseCreatePathVariables = { gameId: string };

@Injectable()
export class MemoryPhaseService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	/**
	 * @deprecated This method will be deprecated in upcoming versions by GameController.update
	 */
	public create(
		path: MemoryPhaseCreatePathVariables,
		body: EmptyRequest,
	): Observable<MemoryPhase> {
		return this.http.post<MemoryPhase>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/memory`,
			body,
		);
	}
}
